window.addEventListener("load", function () {
  /* Scroll dọc grid quy đổi hồn thạch (phải) — scroll by row */
  const $wrap = $("#frame3 .change__card .rows-wrap");
  if ($wrap.length) {
    const verticalStep = () => {
      const $row = $wrap.find(".group__card--row").first();
      if (!$row.length) return 0;
      const style = getComputedStyle($wrap[0]);
      const gap = parseFloat(style.rowGap || style.gap || "0") || 0;
      return $row[0].getBoundingClientRect().height + gap;
    };
    $("#frame3 .change__card .scroll--next").on("click", function (e) {
      e.preventDefault();
      $wrap[0].scrollBy({ top: verticalStep(), behavior: "smooth" });
    });
    $("#frame3 .change__card .scroll--prev").on("click", function (e) {
      e.preventDefault();
      $wrap[0].scrollBy({ top: -verticalStep(), behavior: "smooth" });
    });
  }

  /* Scroll dọc danh sách bộ sưu tập (trái) — 4 row hiển thị, scroll xem thêm */
  const $change = $("#frame3 .gallery .change");
  if ($change.length) {
    const galleryVerticalStep = () => {
      const $row = $change.find("> .change--item").first();
      if (!$row.length) return 0;
      const style = getComputedStyle($change[0]);
      const gap = parseFloat(style.rowGap || style.gap || "0") || 0;
      return $row[0].getBoundingClientRect().height + gap;
    };
    $("#frame3 .gallery > .scroll--next").on("click", function (e) {
      e.preventDefault();
      $change[0].scrollBy({ top: galleryVerticalStep(), behavior: "smooth" });
    });
    $("#frame3 .gallery > .scroll--prev").on("click", function (e) {
      e.preventDefault();
      $change[0].scrollBy({ top: -galleryVerticalStep(), behavior: "smooth" });
    });
  }

  /* Scroll ngang dãy card bộ sưu tập (trái) — chỉ row navigable mới có prev/next */
  $("#frame3 .gallery .change--item.is-navigable").each(function () {
    const $cards = $(this).find(".cards");
    const $prev = $(this).find("> .cards-area > .prev");
    const $next = $(this).find("> .cards-area > .next");
    if (!$cards.length) return;

    const CARDS_PER_STEP = 5;
    const horizontalStep = () => {
      const $first = $cards.find("li").first();
      if (!$first.length) return 0;
      const style = getComputedStyle($cards[0]);
      const gap = parseFloat(style.columnGap || style.gap || "0") || 0;
      return ($first[0].getBoundingClientRect().width + gap) * CARDS_PER_STEP;
    };

    $next.on("click", function (e) {
      e.preventDefault();
      $cards[0].scrollBy({ left: horizontalStep(), behavior: "smooth" });
    });
    $prev.on("click", function (e) {
      e.preventDefault();
      $cards[0].scrollBy({ left: -horizontalStep(), behavior: "smooth" });
    });
  });

  /* Tooltip item — portal vào body, position:fixed, bypass overflow/transform/lazyload */
  const $wraps = $("#frame3 .gallery .item-wrap[data-tooltip]");
  if ($wraps.length) {
    const tipEl = document.createElement("img");
    tipEl.className = "frame3-tooltip";
    tipEl.alt = "";
    document.body.appendChild(tipEl);

    const cache = {};
    $wraps.each(function () {
      const src = this.getAttribute("data-tooltip");
      if (src && !cache[src]) {
        const img = new Image();
        img.src = src;
        cache[src] = img;
      }
    });

    const positionTip = ($item) => {
      const ir = $item[0].getBoundingClientRect();
      const tr = tipEl.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      let x = ir.left + ir.width / 2 - tr.width / 2;
      let y = ir.top - tr.height - 8;
      if (y < 8) y = ir.bottom + 8;
      if (y + tr.height > vh - 8) y = Math.max(8, vh - tr.height - 8);
      if (x < 8) x = 8;
      if (x + tr.width > vw - 8) x = vw - tr.width - 8;
      tipEl.style.left = x + "px";
      tipEl.style.top = y + "px";
    };

    $wraps.each(function () {
      const $w = $(this);
      const $item = $w.find(".item");
      const src = this.getAttribute("data-tooltip");
      if (!$item.length || !src) return;

      $w.on("mouseenter", function () {
        if (tipEl.getAttribute("src") !== src) tipEl.src = src;
        const apply = () => {
          positionTip($item);
          tipEl.style.visibility = "visible";
          tipEl.style.opacity = "1";
        };
        if (tipEl.complete && tipEl.naturalWidth) {
          apply();
        } else {
          tipEl.onload = apply;
        }
      });
      $w.on("mouseleave", function () {
        tipEl.style.opacity = "0";
        tipEl.style.visibility = "hidden";
      });
    });
  }
});
